import { render, staticRenderFns } from "./EmployeeMphInfo.vue?vue&type=template&id=05c05244"
import script from "./EmployeeMphInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeMphInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports